import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAudiComponent } from './simple-icons-audi.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAudiComponent ],
    exports:      [ SimpleIconsAudiComponent ],
    bootstrap:    []
})
export class SimpleIconsAudiModule {}
